var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotPoints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.137L7.5 10.137M17.5 5.13705L7.5 5.13704M17.5 15.137L7.5 15.137M4.16667 10.137C4.16667 10.5973 3.79357 10.9704 3.33333 10.9704C2.8731 10.9704 2.5 10.5973 2.5 10.137C2.5 9.67681 2.8731 9.30371 3.33333 9.30371C3.79357 9.30371 4.16667 9.67681 4.16667 10.137ZM4.16667 5.13704C4.16667 5.59728 3.79357 5.97038 3.33333 5.97038C2.8731 5.97038 2.5 5.59728 2.5 5.13704C2.5 4.67681 2.8731 4.30371 3.33333 4.30371C3.79357 4.30371 4.16667 4.67681 4.16667 5.13704ZM4.16667 15.137C4.16667 15.5973 3.79357 15.9704 3.33333 15.9704C2.8731 15.9704 2.5 15.5973 2.5 15.137C2.5 14.6768 2.8731 14.3037 3.33333 14.3037C3.79357 14.3037 4.16667 14.6768 4.16667 15.137Z",
    stroke: "#38cb89",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotPoints);
export default __webpack_public_path__ + "static/media/dot-points.0a1d7be12e38eef34ec85ac6042d1cd8.svg";
export { ForwardRef as ReactComponent };